module.exports = __webpack_public_path__ + "static/media/referral_326.53526f6f.png";